import { PersonalNameOrder } from '../enums/personal-name-order.enum';
import { SupportedLocale } from '../enums/supported-locale.enum';
const FAQ_DEFAULT_URL = 'https://communications.spottedzebra.co.uk/knowledge-base/candidate-faqs';
export const supportedLocalesMetadata = {
    [SupportedLocale.ENGLISH]: {
        name: {
            english: 'English',
            native: 'English',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.DANISH]: {
        name: {
            english: 'Danish',
            native: 'Dansk',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.GERMAN]: {
        name: {
            english: 'German',
            native: 'Deutsch',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.SPANISH_LATIN_AMERICAN]: {
        name: {
            english: 'Spanish (Latin American)',
            native: 'Español (Latinoamérica)',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.FRENCH]: {
        name: {
            english: 'French',
            native: 'Français',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.INDONESIAN]: {
        name: {
            english: 'Indonesian',
            native: 'Bahasa Indonesia',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.ITALIAN]: {
        name: {
            english: 'Italian',
            native: 'Italiano',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.KOREAN]: {
        name: {
            english: 'Korean',
            native: '한국어',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.EASTERN,
    },
    [SupportedLocale.MALAY]: {
        name: {
            english: 'Malay',
            native: 'Bahasa Melayu',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.DUTCH]: {
        name: {
            english: 'Dutch',
            native: 'Nederlands',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.TURKISH]: {
        name: {
            english: 'Turkish',
            native: 'Türkçe',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.CHINESE]: {
        name: {
            english: 'Chinese (Simplified)',
            native: '中文',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.EASTERN,
    },
    [SupportedLocale.CHINESE_TRADITIONAL]: {
        name: {
            english: 'Chinese (Traditional)',
            native: '中文（繁體）',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.EASTERN,
    },
    [SupportedLocale.HUNGARIAN]: {
        name: {
            english: 'Hungarian',
            native: 'Magyar',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.EASTERN,
    },
    [SupportedLocale.THAI]: {
        name: {
            english: 'Thai',
            native: 'ภาษาไทย',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.PORTUGUESE_BRAZILIAN]: {
        name: {
            english: 'Portuguese (Brazilian)',
            native: 'Português (Brasil)',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.POLISH]: {
        name: {
            english: 'Polish',
            native: 'Polski',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.BULGARIAN]: {
        name: {
            english: 'Bulgarian',
            native: 'Български',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
    [SupportedLocale.SPANISH_EUROPEAN]: {
        name: {
            english: 'Spanish (European)',
            native: 'Español (España)',
        },
        faqURL: FAQ_DEFAULT_URL,
        personalNameOrder: PersonalNameOrder.WESTERN,
    },
};
